import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Row } from 'antd'
import { merchantIndividualDocs, MerchantType, merchantCoporateDocs } from 'helpers/constanst'
import { Data } from 'Store/merchants/types'
import { UploadForm } from 'Components/form'

type Props = {
  detail?: Data
  onUpdateData?: (file: string, key: string) => void
  token?: string
  formData?: any
  setFormData?: (val: any) => void
  isError?: (name: string) => boolean
  isRequired?: (name: string) => boolean
  readOnly?: boolean
}

const MerchantDocument: React.FunctionComponent<Props> = props => {
  const {
    readOnly = false,
    detail,
    token = '',
    isError = () => {},
    isRequired = () => {},
    onUpdateData = () => {},
    formData,
  } = props
  const isIndividual = detail?.type === MerchantType.INDIVIDUAL

  const documentPreview = (title: string, image: string = '', key: string) => (
    <Col md={24} xs={24} key={key}>
      <UploadForm
        token={token}
        onUpdateData={(file: any) => onUpdateData(file, key)}
        currentFile={image}
        folder="merchant"
        listType="picture"
        isPrivate={true}
        name="merchant-document"
        description="ขนาดไม่เกิน 5MB ต่อไฟล์ (.png .jpg .pdf)"
        isRequired={isRequired(key) || false}
        isError={isError(key) || false}
        label={title}
        readOnly={readOnly}
      />
    </Col>
  )

  const document = isIndividual ? merchantIndividualDocs : merchantCoporateDocs

  return (
    <BoxWrapper>
      <BoxTitle>เอกสารเข้าร่วมโครงการ</BoxTitle>
      <Row gutter={16}>
        {document.map((item: any) => {
          return documentPreview(item.name, formData?.[item.key], item.key)
        })}
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

export default MerchantDocument
